import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { FacilityResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * One facility's detail (name, timezone, services). `timezone` is the key field
 * for the court sheet: the whole grid reads in venue-local time.
 */
export function useFacility(facilityId: string | undefined) {
  return useQuery<FacilityResponse>({
    queryKey: queryKeys.booking.facility(facilityId ?? ""),
    queryFn: () => facilityApi.get(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
